import { render } from "./SiteBanner.vue?vue&type=template&id=8d933c22"
import script from "./SiteBanner.vue?vue&type=script&lang=js"
export * from "./SiteBanner.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TEMP\\Website_Corneel\\luisterlive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__